import * as React from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { FormatsListPage } from '../../../features/admin/media-formats/components/formats-list-page';
import { PageTitleContext } from '../../__root';

// ─── Search params schema ─────────────────────────────────────

const FormatsSearchSchema = z.object({
  page: z.number().int().positive().default(1).catch(1),
  pageSize: z.number().int().positive().default(25).catch(25),
  search: z.string().optional().catch(undefined),
  groupId: z.number().optional().catch(undefined),
  isActive: z.boolean().optional().catch(undefined),
});

// ─── Route ───────────────────────────────────────────────────

export const Route = createFileRoute('/admin/dictionaries/formats')({
  validateSearch: FormatsSearchSchema,
  beforeLoad: ({ context }) => {
    const user = context.auth.user;
    if (!user) {
      throw redirect({ to: '/login' });
    }
  },
  component: FormatsRoute,
});

function FormatsRoute() {
  const { setPageTitle } = React.useContext(PageTitleContext);
  const { t } = useTranslation('admin');

  React.useEffect(() => {
    setPageTitle(t('formats.pageTitle'));
  }, [setPageTitle, t]);

  return <FormatsListPage />;
}
